export default __webpack_public_path__ + "static/media/Poppins-Regular.ad19729d.woff2";